type ArrowIconProps = {
  className: string
}

export const ArrowIcon = ({ className }: ArrowIconProps) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.34592 14.3461C3.98468 14.7074 3.98468 15.293 4.34592 15.6543C4.70715 16.0155 5.29283 16.0155 5.65407 15.6543L9.29286 12.0155C9.68339 11.6249 10.3166 11.6249 10.7071 12.0155L14.3459 15.6543C14.7071 16.0155 15.2928 16.0155 15.654 15.6543C16.0153 15.293 16.0153 14.7074 15.654 14.3461L12.0152 10.7073C11.6247 10.3168 11.6247 9.68363 12.0152 9.29311L15.6541 5.65426C16.0153 5.29303 16.0153 4.70735 15.6541 4.34612C15.2928 3.98488 14.7072 3.98488 14.3459 4.34612L10.7071 7.98496C10.3166 8.37548 9.68339 8.37548 9.29286 7.98496L5.65402 4.34612C5.29279 3.98489 4.70711 3.98489 4.34588 4.34612C3.98464 4.70736 3.98464 5.29303 4.34588 5.65427L7.98472 9.29311C8.37524 9.68363 8.37524 10.3168 7.98472 10.7073L4.34592 14.3461Z"
      fill="#14151A"
    />
  </svg>
)
